// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: var(--font-family);
  background-color: var(--surface-ground);
  color: var(--text-color);
  margin: 0;
  padding: 0;
}
header {
  background-color: #333;
  color: white;
  padding: 20px;
  text-align: center;
}
nav {
  display: flex;
  justify-content: center;
  background-color: #333;
  position: relative;
}
nav a {
  color: white;
  padding: 14px 20px;
  text-decoration: none;
  text-align: center;
  position: relative;
}
nav a:hover {
  background-color: #ddd;
  color: black;
}
.menu-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.menu-item {
  background-color: #5c6bc0;
  color: white;
  padding: 15px;
  margin: 10px;
  border-radius: 8px;
  transition: transform 0.3s ease;
}
.menu-item:hover {
  transform: scale(1.1);
  background-color: #3f51b5;
}
.content {
  padding: 20px;
  text-align: center;
}
.content h2 {
  font-size: 2em;
}
.chinese-text {
  font-size: 1.5em;
  color: #4caf50;
}
/* Estilo del submenú */
.submenu {
  display: none; /* Ocultar el submenú inicialmente */
  position: absolute;
  top: 100%; /* Coloca el submenú justo debajo del enlace principal */
  left: 0;
  background-color: #333;
  list-style-type: none;
  padding: 0;
  margin: 0;
  min-width: 160px; /* Ancho mínimo del submenú */
}
.submenu li a {
  color: white;
  padding: 10px;
  text-decoration: none;
  display: block; /* Para que cada enlace ocupe una línea completa */
}
.submenu li a:hover {
  background-color: #ddd;
  color: black;
}
/* Mostrar el submenú cuando se hace hover sobre el contenedor del enlace "Inicio" */
.menu-item:hover .submenu {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,wBAAwB;EACxB,SAAS;EACT,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA,uBAAuB;AACvB;EACE,aAAa,EAAE,oCAAoC;EACnD,kBAAkB;EAClB,SAAS,EAAE,wDAAwD;EACnE,OAAO;EACP,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,gBAAgB,EAAE,6BAA6B;AACjD;AACA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,cAAc,EAAE,kDAAkD;AACpE;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA,oFAAoF;AACpF;EACE,cAAc;AAChB","sourcesContent":["body {\n  font-family: var(--font-family);\n  background-color: var(--surface-ground);\n  color: var(--text-color);\n  margin: 0;\n  padding: 0;\n}\nheader {\n  background-color: #333;\n  color: white;\n  padding: 20px;\n  text-align: center;\n}\nnav {\n  display: flex;\n  justify-content: center;\n  background-color: #333;\n  position: relative;\n}\nnav a {\n  color: white;\n  padding: 14px 20px;\n  text-decoration: none;\n  text-align: center;\n  position: relative;\n}\nnav a:hover {\n  background-color: #ddd;\n  color: black;\n}\n.menu-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 50px;\n}\n.menu-item {\n  background-color: #5c6bc0;\n  color: white;\n  padding: 15px;\n  margin: 10px;\n  border-radius: 8px;\n  transition: transform 0.3s ease;\n}\n.menu-item:hover {\n  transform: scale(1.1);\n  background-color: #3f51b5;\n}\n.content {\n  padding: 20px;\n  text-align: center;\n}\n.content h2 {\n  font-size: 2em;\n}\n.chinese-text {\n  font-size: 1.5em;\n  color: #4caf50;\n}\n/* Estilo del submenú */\n.submenu {\n  display: none; /* Ocultar el submenú inicialmente */\n  position: absolute;\n  top: 100%; /* Coloca el submenú justo debajo del enlace principal */\n  left: 0;\n  background-color: #333;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  min-width: 160px; /* Ancho mínimo del submenú */\n}\n.submenu li a {\n  color: white;\n  padding: 10px;\n  text-decoration: none;\n  display: block; /* Para que cada enlace ocupe una línea completa */\n}\n.submenu li a:hover {\n  background-color: #ddd;\n  color: black;\n}\n/* Mostrar el submenú cuando se hace hover sobre el contenedor del enlace \"Inicio\" */\n.menu-item:hover .submenu {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
